import { Navigation } from "zudoku";
import { sidebar } from "./overview/sidebar"
import { BeyondSandbox } from "../../src/pages/BeyondSandbox";
import { BeyondCompliance } from "../../src/pages/BeyondCompliance";
import { LandingPage } from "../../src/pages/LandingPage";
import { ThirdPartyApis } from "../../src/pages/ThirdPartyApis";
import { NibssApis } from "../../src/pages/NibssApis";

export const navigation: Navigation = [
    {
      type: "custom-page",
      label: "Home",
      path: '/',
      element: <LandingPage />,
      display: 'hide',
    },
    {
      type: "category",
      icon: "home",
      label: "Overview",
      items: sidebar
    },
    {
      type: "category",
      icon: "codesandbox",
      label: "CBN Regulatory Sandbox",
      items: [
        {
          type: 'doc',
          label: "Overview",
          file: "products/beyond-sandbox"
        },
        {
          type: 'doc',
          label: "Authentication",
          file: "products/beyond-sandbox-authentication"
        },
        {
          type: 'custom-page',
          label: 'APIs',
          path: 'products/beyond-sandbox/apis',
          element: <BeyondSandbox />
        }
      ]
    },
//     {
//       type: 'category',
//       icon: 'clipboard-list',
//       label: 'Beyond Compliance',
//       items: [
//         {
//           type: 'doc',
//           label: "Overview",
//           file: "products/beyond-compliance"
//         },
//         {
//             type: 'doc',
//           label: "Authentication",
//           file: "products/beyond-compliance-authentication"
//         },
//         {
//           type: 'custom-page',
//           label: 'APIs',
//           path: 'products/beyond-compliance/apis',
//           element: <BeyondCompliance />
//         }
//       ]
//     },
//     {
//       type: 'category',
//       icon: 'banknote',
//       label: 'Beyond Cash',
//       items: [
//         {
//           type: 'doc',
//           label: 'Overview',
//           file: 'products/beyond-cash'
//         }
//       ]
//     },
    {
      type: 'category',
      icon: 'scale',
      label: 'NRS Tax Compliance Gateway',
      items: [
        {
          type: 'doc',
          label: 'Overview',
          file: 'products/tax-collection-gateway'
        },
        {
          type: 'link',
          label: 'API Reference',
          to: 'products/tax-collection-gateway/api-reference'
        }
      ]
    },
    {
      type: 'category',
      icon: 'scale',
      label: 'Third Party APIs',
      items: [
        {
          type: 'custom-page',
          label: 'Overview',
          path: 'products/third-party-apis',
          element: <ThirdPartyApis />
        },
        {
          type: 'custom-page',
          label: 'NIBSS APIs',
          path: 'products/third-party-apis/nibss',
          element: <NibssApis />,
          display: 'hide',
        },
        {
          type: 'category',
          label: 'NIBSS APIs',
          items: [
            {
              type: 'link',
              label: 'Combined Identity Validation',
              to: 'products/third-party-apis/nibss/combined-identity-validation'
            },
            {
              type: 'link',
              label: 'Phone Number Validation',
              to: 'products/third-party-apis/nibss/phone-number-validation'
            },
            {
              type: 'link',
              label: 'Virtual NIN',
              to: 'products/third-party-apis/nibss/virtual-nin'
            },
            {
              type: 'link',
              label: 'TIN Verification',
              to: 'products/third-party-apis/nibss/tin-verification'
            },
            {
              type: 'link',
              label: 'Core Banking Application',
              to: 'products/third-party-apis/nibss/core-banking-application'
            },
            {
              type: 'link',
              label: 'iGree USSD',
              to: 'products/third-party-apis/nibss/igree-ussd'
            },
          ]
        }
      ]
    }
]
